import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-guest-profile-nudge",
  templateUrl: "./guest-profile-nudge.component.html",
  styleUrls: ["./guest-flow.component.css"],
  standalone: false
})
export class GuestProfileNudgeComponent {
  @Input() public title = "";
  @Input() public description = "";
  @Input() public actionLabel = "";

  @Output() public action = new EventEmitter<void>();
}
